import { z } from "zod";

// Cloudflare Turnstile test site keys: `1x...AA` always passes (no challenge),
// `2x...AB` always fails. We default to the always-passes key for local dev
// so the widget renders without configuration; the real key is set as a
// Cloudflare Pages env var for production deploys. The matching SECRET goes
// into Supabase Auth → CAPTCHA settings.
const TURNSTILE_TEST_KEY_PASS = "1x00000000000000000000AA";

const schema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(20),
  VITE_TURNSTILE_SITE_KEY: z
    .string()
    .min(10)
    .default(TURNSTILE_TEST_KEY_PASS),
  // Sentry. Empty → init is a no-op (useful for local dev). Set the DSN as a
  // Cloudflare Pages env var for production deploys.
  VITE_SENTRY_DSN: z.string().default(""),
  VITE_SENTRY_ENVIRONMENT: z.string().default("production"),
  VITE_SENTRY_TRACES_SAMPLE_RATE: z
    .string()
    .default("0.1")
    .transform((v) => {
      const n = Number(v);
      return Number.isFinite(n) ? Math.max(0, Math.min(1, n)) : 0.1;
    }),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  console.error("Invalid environment variables:", parsed.error.flatten().fieldErrors);
  throw new Error("Invalid env. See console.");
}

export const env = parsed.data;
